import { render, staticRenderFns } from "./FuzzySoftwareTable.vue?vue&type=template&id=0700a0b8"
import script from "./FuzzySoftwareTable.vue?vue&type=script&lang=js"
export * from "./FuzzySoftwareTable.vue?vue&type=script&lang=js"
import style0 from "./FuzzySoftwareTable.vue?vue&type=style&index=0&id=0700a0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports